<template>
  <vlt-modal
    :visible="visible"
    canCancel
     :okText="$t('message.save')"
     :cancelText="$t('message.cancel')"
     :title="$t('message.dashboard.editUser.add_user')"
     @close="$emit('onClose')"
     @confirm="applyChanges"
      :noFooter="editing"
    large
  >
    <div class="Vlt-grid">
      <!--PHONE NUMBER -->
      <div class="Vlt-col Vlt-left Vlt-margin--bottom2" v-if="!editing">
        <h5>{{$t('message.dashboard.editUser.number')}}</h5>
        <div v-if="edit">{{selectedUser.phone}} </div>
        <div v-else class="Vlt-form__element">
          <vlt-field big :error="userNumberError">
            <vlt-input
              id="number"
              type="text"
              :val="selectedUser.phone"
              v-model="selectedUser.phone"
              hint=""
              :label="$t('message.dashboard.editUser.number')"
              :placeholder="$t('message.dashboard.editUser.number')"
              @input="onChangeField('userNumberError')"
              :disabled="this.editing"
            />
          </vlt-field>

        </div>
      </div>
      <div class="Vlt-grid__separator"><!-- Empty line breaker --></div>
      <!--NAME-->
      <div class="Vlt-col">
        <h5>{{$t('message.dashboard.editUser.name')}}</h5>
        <div class="Vlt-form__element">
          <vlt-field big :error="userNameError">
            <vlt-input
              id="name"
              type="text"
              :val="selectedUser.caller_name"
              v-model="selectedUser.caller_name"
              hint=""
              :label="$t('message.dashboard.editUser.name')"
              :placeholder="$t('message.dashboard.editUser.name')"
              @input="onChangeField('userNameError')"
              :disabled="this.editing"
            />
          </vlt-field>
        </div>
      </div>
      <div class="Vlt-grid__separator"><!-- Empty line breaker --></div>


      <!--ROLE-->
      <div >
        <div class="Vlt-col">
          <h5>{{$t('message.dashboard.editUser.role')}}</h5>
          <div class="Vlt-margin--bottom1">
            <vlt-radio
              inline
              name="role"
              :label="$t('message.dashboard.editUser.user')"
              :val = "ROLES.TALENT"
              @input="onChangeRole"
              :checked="selectedUser.role===ROLES.TALENT || !selectedUser.role"
            />
            <vlt-radio
              inline
              name="role"
              :label="$t('message.dashboard.editUser.admin')"
              :val = "ROLES.SUPERVISOR"
              @input="onChangeRole"
              :checked="selectedUser.role===ROLES.SUPERVISOR"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="editing" class="Vlt-col Vlt-col--center">
      <vlt-spinner small></vlt-spinner>
    </div>
    <vlt-callout v-if="error" dismissable @dismissed="error = null"
                 type="critical">
      <h5>{{$t('message.errors.failed_to_edit_user')}}</h5>
    </vlt-callout>

  </vlt-modal>
</template>

<script>
import { cloneDeep } from 'lodash';

import {
  VltModal,
  VltField,
  VltInput,
  VltSpinner,
  VltCallout,
  VltBadge,
  VltRadio,
} from '@vonagevolta/vue';

import EventBus from '../../../utils/event-bus';

import {
    ROLES,
} from "Constants/nciConstants";

export default {
  name: 'EditUserModal',
  components: {
    VltModal,
    VltField,
    VltInput,
    VltSpinner,
    VltCallout,
    // DropdownConvsSelector,
    VltBadge,
    // PhoneNumbersDropdown,
      VltRadio,
  },
  data() {
    return {
      editedConvsObj: null,
      editing: false,
      error: null,
      userNameError: null,
      userNumberError: null,
      selectedUser: {
        caller_name: '',
        phone: '',
        role: ROLES.TALENT,
      },
      ROLES: ROLES,
      validatedNumber: ''
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    origUser: {
      type: Object,
      required: false,
    },
    edit: {
      type: Boolean,
      required: true,
      default: true,
    },
    onSaveUser: {
      type: Function,
      required: true,
    }

  },

  methods: {
    onChangeRole(value) {
      this.selectedUser.role = value;
    },
    onChangeField(errorFieldName) {
      this[errorFieldName] = null;// clean up errors
    },
    async applyChanges() {
      if (!this.validate()) return;

      if (!this.edit) {
          const isValidNumber = this.isValidNumber(this.selectedUser.phone);
          if (!isValidNumber && !this.validatedNumber) {
            this.userNumberError = this.$i18n.t('message.login.error3');
            return;
          }
      } else if (this.edit) {
        const userDataHasChange = this.userDataHasChange();
        if (!userDataHasChange && this.edit) {
            this.$emit('onClose');
            return;
        }
      }

      this.editing = true;
      const userToSend = {...this.selectedUser};
      if (!this.edit) {
        userToSend.phone = this.validatedNumber;
      }
      console.log('userToSend: ', userToSend)
      try {
        await this.onSaveUser(this.edit, userToSend);
      } catch (err) {
        console.error('SAVE USER ERROR:: ', err);
        this.error = true;
      }

      this.$emit('onClose');
      EventBus.$emit('reloadUsers');
      this.editing = false;

    },
    userDataHasChange() {
      return this.origUser.caller_name !== this.selectedUser.caller_name
        || this.origUser.role !== this.selectedUser.role;
    },
    validate() {
      this.userNameError = null;
      this.userNumberError = null;
      let hasErrors = false;
      const errorMsg = this.$i18n.t('message.errors.errorRequiredField');

      if (!this.selectedUser.caller_name.trim()) {
        hasErrors = true;
        this.userNameError = errorMsg;
      }
      if(!this.selectedUser.phone.trim()) {
        hasErrors = true;
        this.userNumberError = errorMsg;
      }
      return !hasErrors;
    },

    async initializeData() {
      this.editing = true;
      if (this.edit) {
        this.selectedUser = cloneDeep(this.origUser);
      } else {
        // this.selectedUser = {
        //     caller_name: '',
        //     phone: '',
        //     role: '',
        // }
      }
      console.log('SELECTED USER: ', this.selectedUser);
      this.editing = false;
    },
    isValidNumber(term) {
        const exp = /(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -.]*\d+)*[) ]*$/g;
        const exp2Str = /^(\+)?[0-9]*$/g;
        let trimmedNumber = term.trim();

        const isValid = exp.test(trimmedNumber);

        let cleanNumber = trimmedNumber.replace('(', '');
        cleanNumber = cleanNumber.replace(')', '');
        cleanNumber = cleanNumber.replace(' ', '');
        cleanNumber = cleanNumber.replace('-', '');
        const isValidLen = cleanNumber.length >= 10;
        const isValid2 = exp2Str.test(cleanNumber);
        if (isValid && isValid2 && isValidLen) {
            if (!cleanNumber.startsWith('+') && cleanNumber.length === 10) {
                this.validatedNumber = `1${cleanNumber}`;
            } else if (cleanNumber.startsWith('+')) {
                this.validatedNumber = cleanNumber.replace('+', '');
            } else {
                this.validatedNumber = cleanNumber;
            }

            return true;
        }
        return false;
    },
    validateNumber(number) {
        if (this.isValidNumber(number)) {
            this.termError = '';
            this.userNumberError = '';
        } else {
            this.termError = this.$i18n.t('message.login.error3');
            this.userNumberError = this.$i18n.t('message.login.error3');
        }
    },
  },
  watch: {
    selectedUser: {
        immediate: true,
        handler(newProp) {
          if (newProp && newProp.phone) {
              this.validateNumber(newProp.phone);
          }
        },
        deep: true
    }
  },
  created() {
    this.initializeData();
  },

};
</script>

<style scoped lang="scss">
  .info-line {
    display: flex;
    justify-content: space-between;

    .label {
      flex: 1 1 0;
      white-space: nowrap;
    }

    .value {
      flex: 2 1 100%;
      text-align: right;
      overflow: hidden;
      white-space: nowrap;

      li {
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
  div.manage-nums-link {
    color: #919eab;
    display: block;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    font-size: 1.4rem;
    line-height: 1.3;
    margin-top: 4px;
    text-align: left;
    font-weight: 400;

    a {
      color: $blue !important;
    }
    a:visited {
      color: $blue !important;
    }
  }

</style>
